export enum ENV_LIST {
    LOCAL = 'local',
    STAGING = 'staging',
    REVIEW_APP = 'review_app',
    DEMO_01 = 'demo01',
    SANDBOX = 'sandbox',
    PRODUCTION = 'production',
}

export enum AvailableToggleFeatures {
    item_stock_connector = 'item_stock_connector',
}

const featuresByEnv = Object.freeze({
    // Usage example:
    // [ENV_LIST.LOCAL]: [AvailableToggleFeatures.ma_feature]
    [ENV_LIST.LOCAL]: [AvailableToggleFeatures.item_stock_connector],
    [ENV_LIST.STAGING]: [AvailableToggleFeatures.item_stock_connector],
    [ENV_LIST.REVIEW_APP]: [AvailableToggleFeatures.item_stock_connector],
    [ENV_LIST.DEMO_01]: [AvailableToggleFeatures.item_stock_connector],
    [ENV_LIST.SANDBOX]: [AvailableToggleFeatures.item_stock_connector],
    [ENV_LIST.PRODUCTION]: [],
});

export function getEnabledFeaturesByEnv(envName: ENV_LIST) {
    return featuresByEnv?.[envName];
}
